module.exports = __webpack_public_path__ + "static/media/ks_testing_video_still.bf8444c4.svg";